import React from "react";
import RefereeOverviewGameRow from "./RefereeOverviewGameRow";
import TableHeader from "./table/TableHeader";

const RefereeUpcomingGames = ({ upcomingGames, UID, handleButtonClick }) => {
  const upcomingGamesArray = upcomingGames ? Object.values(upcomingGames).slice(0, 4) : null;

  return (
    <div className="self-stretch flex-1 flex flex-col text-left font-outfit rounded-2xl overflow-hidden bg-white/5 border border-white/10 backdrop-blur-sm">
        <TableHeader title={"Upcoming Games"} />
      <div className="self-stretch flex flex-col items-center justify-between p-4 text-[0.69rem] gap-2">
        {upcomingGamesArray === null ? (
          <div className="flex flex-1 items-center justify-center py-6">
          <l-dot-pulse size="43" speed="1.3" color="#2d556c"></l-dot-pulse>
        </div>
        ) : (
          upcomingGamesArray.map((game, index) => (
            <RefereeOverviewGameRow
              key={index}
              UID={UID}
              handleButtonClick={handleButtonClick}
              apidata={game}
              bgColor={"bg-royalblue-100"}
              textcolor={"text-white"} 
            />
          ))
        )}
      </div>
    </div>
  );
};

export default RefereeUpcomingGames;
